import script from "./frame.vue?vue&type=script&setup=true&lang=js"
export * from "./frame.vue?vue&type=script&setup=true&lang=js"

import "./frame.vue?vue&type=style&index=0&id=d316031e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\刘正希\\Desktop\\知谦\\zq\\webside\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d316031e"]])

export default __exports__